<template>
  <div class="wh100">
    <div class="wh100 content">
      <my-map
        ref="myMap"
        :channel-map="channelMap"
        :channel-name="channelName"
        :mapChangeIndex="mapChangeIndex"
        :river-data="riverList"
        @marker-click="markerClick"
        @river-click="riverClick"
      >
        <div class="top-shadow"></div>
      </my-map>
      <ChannelList
        class="z999"
        :channelData="channelData"
        :default-index="0"
        textField="ChannelName"
        @item-click="channelClick"
      ></ChannelList>
      <div class="tl_ys z999">
        <div @click="markerControl('dq')">
          <img
            :src="
              markerLegend.dq ? '/map/legend/dq.png' : '/map/legend/dq_off.png'
            "
          /><span
            >淀区断面
            <span style="color: #03aaff">{{ stationNum.dq }}</span></span
          >
        </div>
        <div @click="markerControl('hl')">
          <img
            :src="
              markerLegend.hl ? '/map/legend/hl.png' : '/map/legend/hl_off.png'
            "
          /><span
            >河流断面
            <span style="color: #03aaff">{{ stationNum.hl }}</span></span
          >
        </div>
        <div @click="markerControl('ws')">
          <img
            :src="
              markerLegend.ws ? '/map/legend/ws.png' : '/map/legend/ws_off.png'
            "
          /><span
            >污水处理厂
            <span style="color: #03aaff">{{
              sewageNum.cz + sewageNum.gy + sewageNum.qt
            }}</span></span
          >
        </div>
      </div>
      <div class="pollution-level">
        <div class="pollution-level-unit">
          <div>图例</div>
        </div>
        <div class="pollution-level-val">
          <div class="pollution-level-label-top">
            <span>离线</span>
            <span></span>
            <span
              v-for="(item, index) in channelPieceStandard"
              :key="new Date().getTime() + index"
              >{{ item.label }}</span
            >
          </div>
          <div class="pollution-level-bar">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </div>
      <RightPanel width="20%" class="z999">
        <ToolBox
          @reset-view="resetView"
          @measure-line="startMeasureLine"
          @measure-area="startMeasureArea"
          @clear-map="clearMap"
          style="left: -2vw; top: 20px; position: absolute"
        ></ToolBox>
        <TabPanel :titles="['功能区', '断面', '污水处理厂']" ref="myTab">
          <template slot="content1">
            <div class="tab1 wh100">
              <RiverNum :riverNum="riverNum"></RiverNum>
              <div class="flex1">
                <RiverList
                  :river-data="riverList"
                  @flyRiver="flyRiver"
                ></RiverList>
              </div>
            </div>
          </template>
          <template slot="content2">
            <div class="tab1 wh100">
              <StationNum :stationNum="stationNum"></StationNum>
              <div class="flex1">
                <StationList
                  :station-data="stationList"
                  @fly="fly"
                ></StationList>
              </div>
            </div>
          </template>
          <template slot="content3">
            <div class="tab1 wh100">
              <SewageNum :sewageNum="sewageNum"></SewageNum>
              <div class="flex1">
                <SewageList :sewage-data="sewageList" @fly="fly"></SewageList>
              </div>
            </div>
          </template>
        </TabPanel>
      </RightPanel>
    </div>

    <el-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      class="stationDialog"
      @opened="StationOpend"
    >
      <div slot="title" class="dialog-title-box">
        <div>断面详情</div>
      </div>
      <transition name="fade-transform" mode="out-in">
        <StationDialog
          ref="myStation"
          :stationName="stationName"
        ></StationDialog>
      </transition>
    </el-dialog>

    <el-dialog :visible.sync="sewageDV" class="sewageDialog">
      <div slot="title" class="dialog-title-box">
        <div>污水处理厂详情</div>
      </div>
      <transition name="fade-transform" mode="out-in">
        <SewageDialog
          ref="sewageDialog"
          :SewageData="sewageData"
        ></SewageDialog>
      </transition>
    </el-dialog>

    <el-dialog
      :visible.sync="riverDV"
      class="riverDialog"
      :close-on-click-modal="false"
      @opened="RiverOpend"
    >
      <div slot="title" class="dialog-title-box">
        <div>河流详情-{{ stationName }}</div>
      </div>
      <transition name="fade-transform" mode="out-in">
        <RiverDialog ref="myRiver" :riverName="stationName"></RiverDialog>
      </transition>
    </el-dialog>
  </div>
</template>
<script>
import RightPanel from "../../components/Pannel/RightPannel";
import TabPanel from "./components/TabPanel";
import RiverNum from "./components/RiverNum";
import StationNum from "./components/StationNum";
import SewageNum from "./components/SewageNum";
import RiverList from "./components/RiverList";
import StationList from "./components/StationList";
import SewageList from "./components/SewageList";

import ChannelList from "./components/ChannelList";
import MyMap from "./components/Map";
import ToolBox from "./components/ToolBox";

import StationDialog from "./components/Dialog/StationDialog";
import SewageDialog from "./components/Dialog/SewageDialog";
import RiverDialog from "./components/Dialog/RiverDialog";
export default {
  components: {
    RightPanel,
    TabPanel,
    RiverNum,
    StationNum,
    SewageNum,
    RiverList,
    StationList,
    SewageList,
    MyMap,
    ToolBox,
    StationDialog,
    SewageDialog,
    RiverDialog,
    ChannelList,
  },
  data() {
    return {
      stationName: "20200014",
      channelName: "",
      channelMap: "",
      channelUnit: "",
      channelData: [],
      channelPieceStandard: [
        { label: "Ⅰ类" },
        { label: "Ⅱ类" },
        { label: "Ⅲ类" },
        { label: "Ⅳ类" },
        { label: "Ⅴ类" },
        { label: "劣Ⅴ类" },
      ],
      riverNum: {
        total: 0,
        normal: 0,
        out: 0,
      },
      riverList: [],
      stationNum: {
        total: 0,
        dq: 0, //淀区断面数量
        hl: 0, //河流断面数量
      },
      stationList: [],
      sewageNum: {
        total: 0,
        cz: 0, //城镇
        gy: 0, //工业
        qt: 0, //其他
      },
      sewageList: [],
      sewageData: null,
      sewageDV: false,
      riverDV: false,
      dialogVisible: false,
      markerLegend: {
        cj: true,
        dq: true,
        hl: true,
        ws: true,
        wry: true,
      },
      mapChangeIndex: 0,
    };
  },
  methods: {
    markerControl(type) {
      this.$refs.myMap.markerShow(type);
      this.markerLegend[type] = !this.markerLegend[type];
    },

    GetMapRiver() {
      let that = this;
      that.$api.get(
        "/Map/GetMapRiver",
        null,
        function (res) {
          if (res.code == 200) {
            res.data.funtions.forEach(function (item, index) {
              if (item.CurWaterLevel > item.TargetWaterLevel)
                that.riverNum.out++;
              else that.riverNum.normal++;
            });
            that.riverList = res.data.funtions;
            that.$refs.myMap.initRiver(res.data.rivers);
          }
        },
        function () {},
        true
      );
    },
    GetMapStation() {
      let that = this;
      that.$api.get(
        "/Map/GetMapStation",
        null,
        function (res) {
          if (res.code == 200) {
            res.data.forEach(function (item, index) {
              if (item.StationType == "河流") that.stationNum.hl++;
              else that.stationNum.dq++;
            });
            that.stationList = res.data;
            that.$refs.myMap.initStationMarker(that.stationList);
          }
        },
        function () {},
        true
      );
    },
    GetMapSewage() {
      let that = this;
      that.$api.get(
        "/Map/GetMapSewage",
        null,
        function (res) {
          if (res.code == 200) {
            res.data.forEach(function (item, index) {
              if (item.SewageType == "城镇污水处理厂") that.sewageNum.cz++;
              else if (item.SewageType == "工业污水集中处理厂")
                that.sewageNum.gy++;
              else that.sewageNum.qt++;
            });
            that.sewageList = res.data;
            that.$refs.myMap.setSewageMarker(that.sewageList);
          }
        },
        function () {},
        true
      );
    },
    markerClick(marker, extData) {
      if (marker.options.type == "ws") {
        this.sewageData = extData;
        this.sewageDV = true;
      } else {
        this.stationName = extData.StationName;
        this.dialogVisible = true;
      }
    },
    riverClick(river, extData) {
      this.stationName = extData.properties.NAME;
      this.riverDV = true;
    },
    RiverOpend() {
      this.$refs.myRiver.loadData();
    },
    StationOpend() {
      this.$refs.myStation.loadData();
    },
    resetView() {
      this.$refs.myMap.resetView();
    },

    startMeasureLine() {
      this.$refs.myMap.startMeasureLine();
    },
    startMeasureArea() {
      this.$refs.myMap.startMeasureArea();
    },
    clearMap() {
      this.$refs.myMap.clearMap();
    },
    fly(lat, lon, zoomIndex) {
      this.$refs.myMap.fly(lat, lon, zoomIndex);
    },
    flyRiver(riverName, zoomIndex) {
      this.$refs.myMap.flyRiver(riverName, zoomIndex);
    },
    GetChannelData() {
      let that = this;
      that.$api.get(
        "/Map/GetShowChannelInfo",
        null,
        function (res) {
          if (res.code == 200) {
            that.channelData = res.data;
            //默认选中第一个指标
            that.channelName = res.data[0].ChannelName;
            that.channelMap = res.data[0].ChannelMap;
            that.channelUnit = res.data[0].ChannelUnit;
            //that.createPollutionLevel(res.data[0].PieceStandard);
            that.mapChangeIndex++;
          }
        },
        function () {},
        true
      );
    },
    channelClick(index, item) {
      this.channelName = item.ChannelName;
      this.channelMap = item.ChannelMap;
      this.channelUnit = item.ChannelUnit;
      this.mapChangeIndex++;
    },
  },
  mounted() {
    this.GetChannelData();
    this.GetMapRiver();
    this.GetMapStation();
    this.GetMapSewage();
  },
};
</script>
<style lang="less" scoped>
* {
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  -o-box-sizing: border-box;
  -ms-box-sizing: border-box;
  outline: medium;
}

/deep/ .stationDialog {
  .el-dialog {
    width: 50%;
    height: 50%;
    background: url(../../assets/map/tc_bj2.png) no-repeat center;
    background-size: 100% 100%;

    .el-dialog__header {
      background: unset;
      border-bottom: unset;
      padding: 20px 30px 10px;
      font-size: 1rem;
      color: #00e4ff;
    }
    .el-dialog__body {
      padding: 10px 20px;
      height: 80%;
      opacity: 1;
      color: #00e4ff;
      background: rgba(0, 0, 0, 0.1);
    }
  }
}
/deep/ .sewageDialog {
  .el-dialog {
    width: 30%;
    height: 35%;
    background: url(../../assets/map/tc_bj1.png) no-repeat center;
    background-size: 100% 100%;

    .el-dialog__header {
      background: unset;
      border-bottom: unset;
      padding: 20px 30px 10px;
      font-size: 1rem;
      color: #00e4ff;
    }
    .el-dialog__body {
      padding: 10px 20px;
      height: 80%;
      opacity: 1;
      color: #00e4ff;
      background: rgba(0, 0, 0, 0.1);
    }
  }
}

/deep/ .riverDialog {
  .el-dialog {
    width: 70%;
    height: 65%;
    background: url(../../assets/map/tc_bj2.png) no-repeat center;
    background-size: 100% 100%;

    .el-dialog__header {
      background: unset;
      border-bottom: unset;
      padding: 30px 40px 10px;
      font-size: 1rem;
      color: #00e4ff;
    }
    .el-dialog__body {
      padding: 10px 20px;
      height: 82%;
      opacity: 1;
      color: #00e4ff;
      background: rgba(0, 0, 0, 0.1);
    }
    .el-dialog__headerbtn {
      top: 30px;
      right: 40px;
    }
  }
}
/deep/ .el-drawer__body {
  height: 100%;
}
/deep/ .abow_dialog .el-dialog__body {
  height: calc(80%) !important;
  overflow: hidden;
  overflow-y: auto;
}
/deep/ .abow_dialog .el-dialog {
  height: calc(50%) !important;
}
/deep/ .abow_dialog_river .el-dialog {
  height: calc(75%) !important;
}
/deep/ .abow_dialog_river .el-dialog__body {
  height: calc(85%) !important;
}
/deep/ .abow_dialog_sewage .el-dialog {
  height: calc(50%) !important;
}
/deep/ .abow_dialog_sewage .el-dialog__body {
  height: calc(85%) !important;
}
.dialog-title-box {
  display: flex;
  justify-content: space-between;
  align-items: center;

  width: calc(100% - 40px);
  i {
    margin-right: 15px;
    cursor: pointer;
    font-size: 22px;
  }
  i:hover {
    color: #48c9a2;
  }
}
.z999 {
  z-index: 999;
}
.content {
  position: relative;
}
.top-shadow {
  position: absolute;
  top: 0;
  height: 0;
  width: 100%;
  z-index: 999;
  box-shadow: 0 17px 100px 50px #141414;
}
ul,
li,
span,
p,
h1,
h2,
h3,
h4,
h5,
h6,
a,
dl,
dt,
dd,
input {
  padding: 0;
  margin: 0;
  list-style: none;
  text-decoration: none;
  font-weight: normal;
  font-style: normal;
  font-family: "Microsoft yahei";
}

.tab1 {
  display: flex;
  flex-direction: column;
}
.flex1 {
  width: 100%;
  height: 0;
  overflow: hidden;
  flex: 1;
}

.tl_ys {
  width: 8.1vw;
  height: 9.68vw;
  background: rgba(79, 79, 79, 0.25);
  position: absolute;
  bottom: 1.2vw;
  left: 0.7vw;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  padding: 0.4vw;
  color: #00faf9;
  font-size: 0.7vw;
  div {
    cursor: pointer;
    display: flex;
    align-items: center;
  }
  img {
    width: 1vw;
    height: 1vw;
    margin-right: 0.5vw;
  }
}
.pollution-level {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  bottom: 0.2vh;
  left: 8.7vw;
  width: 24.88vw;
  height: 6.68vh;
  color: #fff;
  z-index: 1000;
  font-size: 0.44vw;
  .pollution-level-val {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 87%;
  }
  .pollution-level-unit {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-right: 2px;
  }
  .pollution-level-unit div:first-child {
    border-bottom: 1px solid #fff;
  }
  .pollution-level-label {
    width: 100%;
    position: relative;
    height: 15px;
    span {
      display: inline-block;
      position: absolute;
    }
    span:nth-child(1) {
      left: 0;
    }
    span:nth-child(2) {
      left: 7.14%;
    }
    span:nth-child(3) {
      left: 13.28%;
    }
    span:nth-child(4) {
      left: 26.56%;
    }
    span:nth-child(5) {
      left: 40.84%;
    }
    span:nth-child(6) {
      left: 55.12%;
    }
    span:nth-child(7) {
      left: 69.4%;
    }
    span:nth-child(8) {
      left: 83.68%;
    }
    span:nth-child(9) {
      left: 97%;
    }
  }
  .pollution-level-label:first-child {
    margin-bottom: 7px;
  }

  .pollution-level-bar {
    width: 100%;
    span {
      box-sizing: border-box;
      border-left: 1px solid #fff;
      display: inline-block;
      height: 10px;
    }
    span:nth-child(1) {
      width: 7.14%;
      background: #acacac;
    }
    span:nth-child(2) {
      width: 0;
      background: #3cc7f5;
    }
    span:nth-child(3) {
      width: 14.28%;
      background: #3cc7f5;
    }
    span:nth-child(4) {
      width: 14.28%;
      background: #11abf1;
    }
    span:nth-child(5) {
      width: 14.28%;
      background: #5dd420;
    }
    span:nth-child(6) {
      width: 14.28%;
      background: #ffc000;
    }
    span:nth-child(7) {
      width: 14.28%;
      background: #fd8200;
    }
    span:nth-child(8) {
      width: 14.28%;
      background: #fd3c00;
    }
  }
  .pollution-level-label-top {
    width: 100%;
    span {
      display: inline-block;
      height: 17px;
      text-align: center;
      vertical-align: middle;
    }
    span:nth-child(1) {
      width: 7.14%;
    }
    span:nth-child(2) {
      width: 0;
    }
    span:nth-child(3) {
      width: 14.28%;
    }
    span:nth-child(4) {
      width: 14.28%;
    }
    span:nth-child(5) {
      width: 14.28%;
    }
    span:nth-child(6) {
      width: 14.28%;
    }
    span:nth-child(7) {
      width: 14.28%;
    }
    span:nth-child(8) {
      width: 14.32%;
    }
  }
}
</style>